// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/add.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FullAnalysisAddFolderPanel{
    display: flex;
    gap: 10px;
    margin-top: 22px;
}

.FullAnalysisAddFolderPanel_button{
    display: flex;
    gap: 5px;
}

.FullAnalysisAddFolderPanel_button:hover{
    color: #f90;
}

.FullAnalysisAddFolderPanel_button_icon{
    width: 15px;
    height: 15px;
    border-radius: 100%;
    flex-shrink: 0;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 12.5px;
    background-position: center;
    background-repeat: no-repeat;
}

.FullAnalysisAddFolderPanel_button_text{
    font-size: calc(12px * var(--fontScaler));
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/fullAnalysis/FullAnalysisAddFolderPanel.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;;IAEd,yDAAmD;IACnD,uBAAuB;IACvB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,yCAAyC;AAC7C","sourcesContent":[".FullAnalysisAddFolderPanel{\n    display: flex;\n    gap: 10px;\n    margin-top: 22px;\n}\n\n.FullAnalysisAddFolderPanel_button{\n    display: flex;\n    gap: 5px;\n}\n\n.FullAnalysisAddFolderPanel_button:hover{\n    color: #f90;\n}\n\n.FullAnalysisAddFolderPanel_button_icon{\n    width: 15px;\n    height: 15px;\n    border-radius: 100%;\n    flex-shrink: 0;\n\n    background-image: url('../../../../assets/add.svg');\n    background-size: 12.5px;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.FullAnalysisAddFolderPanel_button_text{\n    font-size: calc(12px * var(--fontScaler));\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
